module.exports = __webpack_public_path__ + "assets/img/bg_operaterule_circle.0d31cb70.png";